export default __webpack_public_path__ + "static/media/projects_image.0a806256.svg";